// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28y7k","productName":"Table_productName__20kOx"};